import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-four-o-four',
    templateUrl: './four-o-four.component.html',
    styleUrls: ['./four-o-four.component.scss'],
    standalone: true,
    imports: [RouterLink]
})
export class FourOFourComponent {

}
